import React, { useState, useEffect } from "react";
import {
  CardTitle,
} from "reactstrap";
import moment from 'moment';
//redux
import { connect } from "react-redux";
//paginação
import Pagination from "../../../../components/Paginationv3";
// backdrops
import Alert from '../../../../components/Backdrops/Alert';
import Loading from '../../../../components/Backdrops/Loading';
// router
import { useLocation } from "react-router-dom";
//service
import leadCollectorService from "../../../../utils/services/leadCollector";
import ConfigValueModel from '../../../../utils/models/ConfigValueModel';

import ConfigurationsList from './ConfigurationsList';

function LeadCollectorConfigurations(props) {
  const location = useLocation();
  const eventId = location.state.idEvent;
  const foundProducts = props.state.global_user_data.data.foundProducts;

  const [isLoading, setIsLoading] = useState(false);
  const [loadingControl, setLoadingControl] = useState({
    open: false,
    message: '',
  });
  const [alertControl, setAlertControl] = useState({
    open: false,
    title: '',
    message: '',
    status: '', // success, warning, error
  });
  const [configsList, setConfigsList] = useState([]);
  const [configValuesForm, setConfigValuesForm] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Carregando' });

      let _configsList = await leadCollectorService.getConfigs();
      setConfigsList(_configsList.data);

      await getConfigValuesForm(_configsList.data);

    } catch (error) {
      console.log('Error getData', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    async function getConfigValuesForm(localConfigsList = []) {
      let _configValuesForm = await leadCollectorService.getConfigValues(
        eventId,
      );
      let _form = {};
      for (let i = 0; i < localConfigsList.length; i++) {
        let _configValue = _configValuesForm.data.find(c => { return c.config === localConfigsList[i].code });
        if (!_configValue) {
          _configValue = ConfigValueModel({
            id: '',
            adminPlusEventId: eventId,
            config: localConfigsList[i].code,
            value: '',
          });
        }
        _form = {
          ..._form,
          [_configValue.config]: _configValue.value,
        }
      }

      setConfigValuesForm(_form);
    }
  }, [configsList, configValuesForm]);

  const trySaveConfigs = React.useCallback(async () => {
    try {
      setLoadingControl({ ...loadingControl, open: true, message: 'Salvando' });

      let _return = validateForm();
      if (_return.errorMessage) {
        setAlertControl({
          open: true,
          title: '',
          message: _return.errorMessage,
          status: 'warning', // success, warning, error
        });
        return;
      }

      await saveConfigs(_return.form);

      setAlertControl({
        ...alertControl,
        open: true,
        title: 'Salvo',
        message: 'Configurações salvas com sucesso',
        status: 'success'
      });

    } catch (error) {
      console.log('Error trySaveConfigs', error);
      setAlertControl({
        open: true,
        title: 'Erro',
        message: error.message || 'Não foi possível realizar esta operação',
        status: 'error', // success, warning, error
      });
    } finally {
      setLoadingControl({ ...loadingControl, open: false });
    }

    function validateForm() {
      let _return = { form: { ...configValuesForm }, errorMessage: '' };
      if (_return.form.SYSTEM_BASE === '' || _return.form.SYSTEM_BASE === 'INTEEGRA_EVENTOS') {
        _return.form.SYSTEM_BASE = 'INTEEGRA_EVENTOS';
        _return.form.SYSTEM_BASE_ID = eventId;
      }
      if (
        (_return.form.SYSTEM_BASE === 'MICE' || _return.form.SYSTEM_BASE === 'MICE_SANT') &&
        !_return.form.SYSTEM_BASE_ID
      ) {
        _return.errorMessage = 'ID do evento obrigatório';
      }

      return _return;
    }

    async function saveConfigs(localConfigValuesForm) {
      let _count = 0;
      do {
        let _code = configsList[_count].code;

        await leadCollectorService.saveConfig(
          eventId,
          _code,
          localConfigValuesForm[_code],
        );

        _count++;
      } while (_count < configsList.length);
    }
  }, [configsList, configValuesForm])

  return (
    <div>
      <CardTitle>Configurações</CardTitle>
      <ConfigurationsList
        configValuesForm={configValuesForm}
        setConfigValuesForm={setConfigValuesForm}
        trySaveConfigs={trySaveConfigs}
      />

      <Loading loadingControl={loadingControl} />
      <Alert
        alertControl={alertControl}
        setAlertControl={setAlertControl}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(LeadCollectorConfigurations);
